import "@js-temporal/polyfill";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { applyZIndexCssVars } from "./z-index.js";

applyZIndexCssVars();

/**
 * Main application entry point
 * Renders the React application to the DOM
 */
const rootElement = document.getElementById("root");
if (rootElement) {
  createRoot(rootElement).render(<App />);
} else {
  console.error("Root element not found");
}
